module.exports = __webpack_public_path__ + "static/media/Notification.477867ce.svg";